<nav class="top-nav">
    <div class="container-fluid">
        <div class="row center-align">
            <div class="col-md-4">
                <ul class="list-unstyled contact">
                    <li class="hvr-icon-spin">
                        <i nz-icon nzType="mobile" class="hvr-icon" nzTheme="outline"></i>
                        002-01141087755
                    </li>
                    <li class="comp-mail">
                        <span>info@CodesRoots.com</span>                        
                    </li>                 
                </ul>
            </div>
            <div class="col-md-4">
                <app-socil-media></app-socil-media>
            </div>
            <div class="col-md-4">
                <div class="stat">
                    <p>
                        رقم السجل التجاري: <span id="js_counter">72647</span>
                    </p>
                </div>
            </div>                        
        </div>
    </div>
</nav>